<div *ngIf="selectedPOS && !connected">
    <div class="info">
        <div class="POS-logo"
             [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/Ascend.svg)'}"></div>
        <div class="write-up">{{'onboarding.messages.ascend_not_connected_temporary' | translate}}
        </div>
    </div>
</div>